import { Component, inject } from '@angular/core';
import { ToasterService } from '#services';

@Component({
  selector: 'app-toaster',
  imports: [],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss',
})
export class ToasterComponent {
  private _toaster = inject(ToasterService);
  messages = this._toaster.messages;

  dismiss(id: number): void {
    this._toaster.remove(id);
  }
}
